 
 
 
 
 
 
/**
 * @ignore
 * This class provides functionality of drawing routes based on provided GeoJSON object and routing context
 */
/* jshint nomen:false */
define([
    'leaflet',
    'services/popupContentGenerator/pointHTMLContentGenerator',
    'services/routing/routingContext',
    '../svgIcon'
],
function(L, pointHTMLContentGenerator, RoutingContext, SvgIcon) {
    'use strict';
    var startIcon = new SvgIcon({
            background: {
                iconSize: [30, 30],
                iconAnchor: [15, 15],
                icon: 'icon-shield',
                noPlainSVG: false
            },
            icon: {
                iconSize: [30, 30],
                iconAnchor: [0, 0],
                icon: 'icon-start-white',
                noPlainSVG: false
            }
        }),
        endIcon = new SvgIcon({
            background: {
                iconSize: [30, 30],
                iconAnchor: [15, 15],
                icon: 'icon-shield',
                noPlainSVG: false
            },
            icon: {
                iconSize: [30, 30],
                iconAnchor: [0, 0],
                icon: 'icon-end-white',
                noPlainSVG: false
            }
        }),
        routeOptions = {
            style: {
                color: '#00d7ff',
                opacity: 0.8
            }
        },
        supportRouteOptions = {
            color: '#00d7ff',
            opacity: 0.8,
            dashArray: [5, 5]
        };

    function updateRoutingContext(data) {
        var removedMarkerPosition = data.position;
        if (!this._routingContext) {
            return;
        }

        if (this._startMarker && this._startMarker.getLatLng().equals(removedMarkerPosition)) {
            this._routingContext.startPoint(null);
        } else if (this._endMarker && this._endMarker.getLatLng().equals(removedMarkerPosition)) {
            this._routingContext.endPoint(null);
        }
    }

    function RouteDrawer() {
        this._route = null;
        this._startMarker = null;
        this._endMarker = null;
        this._routingContext = null;
        this._supportRoutes = [];
        this._popupGenerator = pointHTMLContentGenerator({
            address: true,
            coordinates: true,
            actions: {
                remove: {
                    onActionClick: updateRoutingContext.bind(this)
                }
            }
        });
    }

    function isJsonRouteEmpty(jsonRoute) {
        return !(jsonRoute && jsonRoute.features && jsonRoute.features.length && jsonRoute.features[0].geometry &&
            jsonRoute.features[0].geometry.coordinates && jsonRoute.features[0].geometry.coordinates.length);
    }

    function getCoordinateFromJsonRoute(jsonRoute, index) {
        var coordinates = jsonRoute.features[0].geometry.coordinates;
        coordinates = Array.prototype.slice.call(coordinates, 0);
        if (index < 0) {
            return coordinates.splice(index)[0].reverse();
        } else {
            return coordinates[index].reverse();
        }
    }

    RouteDrawer.prototype.__getStartPointFromJsonRoute = function(jsonRoute) {
        if (isJsonRouteEmpty(jsonRoute)) {
            return this._routingContext.startPoint();
        }

        return L.latLng(getCoordinateFromJsonRoute(jsonRoute, 0));
    };

    RouteDrawer.prototype.__getEndPointFromGeoJson = function(jsonRoute) {
        if (isJsonRouteEmpty(jsonRoute)) {
            return this._routingContext.endPoint();
        }

        return L.latLng(getCoordinateFromJsonRoute(jsonRoute, -1));
    };

    function areLatLngEquals(latLng1, latLng2) {
    //if latlngs are very close to each other
    //(the difference is on th 6th place after the comma) they are considered equal
        return latLng1.equals(latLng2, 0.000009);
    }

    function removeArrayOfComponents(components) {
        components.forEach(function(component) {
            component.remove();
        });
    }

    /**
     * @ignore
     * This method creates:
     * * route itself using provided jsonRoute param
     * * start and end marker using information provided by routing context
     * * supporting routes which represent routes from route start/end point to start/end marker
     *
     * @param {GeoJSON} jsonRoute GeoJson object with LineString geometry
     */
    RouteDrawer.prototype._drawRoute = function(jsonRoute) {
        var routeStartPoint, routeEndPoint;
        this._removeComponent('_route');
        removeArrayOfComponents(this._supportRoutes);
        this._supportRoutes = [];
        this._updateMarkers();
        if (isJsonRouteEmpty(jsonRoute)) {
            return;
        }
        this._route = L.geoJson(jsonRoute, routeOptions);
        routeStartPoint = this.__getStartPointFromJsonRoute(jsonRoute);
        if (!areLatLngEquals(this._routingContext.startPoint(), routeStartPoint)) {
            this._supportRoutes.push(L.polyline([routeStartPoint, this._routingContext.startPoint()],
                supportRouteOptions));
        }
        routeEndPoint = this.__getEndPointFromGeoJson(jsonRoute);
        if (!areLatLngEquals(this._routingContext.endPoint(), routeEndPoint)) {
            this._supportRoutes.push(L.polyline([routeEndPoint, this._routingContext.endPoint()],
                supportRouteOptions));
        }
    };

    RouteDrawer.prototype._removeComponent = function(componentName) {
        if (this[componentName]) {
            this[componentName].remove();
            this[componentName] = null;
        }
    };

    RouteDrawer.prototype._createMarker = function(markerName, position) {
        var options, icon = markerName.indexOf('start') === 1 ? startIcon : endIcon;
        if (!position) {
            return;
        }

        options = {position: {lat: position.lat, lon: position.lng}, type: 'main'};
        this[markerName] = L.marker(position, {icon: icon});
        this[markerName].bindPopup(this._popupGenerator(options).getHtmlElement());
    };

    /**
     * This method creates start/end markers based on information provided by routing context
     *
     * @ignore
     */
    RouteDrawer.prototype._updateMarkers = function() {
        this._updateMarker('_startMarker', this._routingContext.startPoint());
        this._updateMarker('_endMarker', this._routingContext.endPoint());
    };

    /**
     * @ignore
     * Attaches RouteDrawer instance to a map and its routing context. From this point RouteDrawer
     * instance will provide visual representation of any further actions taken on routing context.
     *
     * @param {L.Map} map Leaflet map
     */
    RouteDrawer.prototype.addTo = function(map) {
        this._map = map;
        this._setRoutingContext(map._routingContext);
    };

    RouteDrawer.prototype.remove = function() {
        this._map = null;
        this._routingContext.off(RoutingContext.Events.PROPERTY_VALUE_CHANGED, this._routingContextUpdatesListener);
        this._routingContextUpdatesListener = null;
        this._routingContext = null;
    };

    RouteDrawer.prototype._addAssetsToMap = function() {
        var elementsPossibleToAdd = [this._route, this._startMarker, this._endMarker].concat(this._supportRoutes),
            map = this._map;
        if (!map) {
            return;
        }

        elementsPossibleToAdd.forEach(function(elementToAdd) {
            if (elementToAdd) {
                elementToAdd.addTo(map);
            }
        });

        if (this._route) {
            map.fitBounds(this._route.getBounds(), {padding: [5, 5]});
        }
    };

    RouteDrawer.prototype._updateMarker = function(markerName, currentPosition) {
        this._removeComponent(markerName);
        this._createMarker(markerName, currentPosition);
        if (this._route) {
            this._removeComponent('_route');
            removeArrayOfComponents(this._supportRoutes);
            this._supportRoutes = [];
        }
    };

    function updateRoutingAssetsOnRoutingContextUpdate(eventData) {
        var propertyName = eventData.name, propertyCurrentValue = eventData.currentValue,
            pointToMarkerMapping = {
                'startPoint': '_startMarker',
                'endPoint': '_endMarker'
            };

        if (Object.keys(pointToMarkerMapping).indexOf(propertyName) !== -1) {
            this._updateMarker(pointToMarkerMapping[propertyName], propertyCurrentValue);
        } else {
        //route updated
            this._drawRoute(propertyCurrentValue);
        }
        this._addAssetsToMap();
    }

    RouteDrawer.prototype._setRoutingContext = function(routingContext) {
        this._routingContext = routingContext;
        this._routingContextUpdatesListener = updateRoutingAssetsOnRoutingContextUpdate.bind(this);
        this._routingContext.on(RoutingContext.Events.PROPERTY_VALUE_CHANGED, this._routingContextUpdatesListener);
    };

    return RouteDrawer;
});



// WEBPACK FOOTER //
// ./display/layers/routeDrawer.js